import { ExternalConnectionContact, ID } from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type GetExternalConnectionContactsPayload = {
  connectionId: ID;
};

export type GetExternalConnectionContactsOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: GetExternalConnectionContactsPayload;
};

export const getExternalConnectionContacts = async <TFunctions>(
  options: GetExternalConnectionContactsOptions<TFunctions>,
): Promise<ExternalConnectionContact[]> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<
    GetExternalConnectionContactsPayload,
    ExternalConnectionContact[]
  >(functions, 'externalConnections-getContacts');

  const { data } = await callable(payload);

  return data;
};
